export default __webpack_public_path__ + "static/assets/61eb92d6f6d535ed6803dad66f8c75ac.png";